import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Menu, MenuItem } from "@mui/material";
import React from "react";
import { MuiIconButton } from "../../../../components";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { STATUS_BADGE_TYPE } from "../../../../components/statusBadge/StatusBadge";
import { MODULE_PERMISSIONS } from "../../../../helpers/constants";
import { useNavigationSiteCore } from "../../../../hooks/useNavigationSiteCore";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import {
  PurchaseOrder,
  PurchaseOrderActionType,
} from "../../modelsAndSchemas/Models";
import { purchaseOrdersListSiteCoreKeys } from "../../siteCore/SiteCoreKeys";

interface PurchaseOrderActionProps {
  purchaseOrder: PurchaseOrder;
  isEditable?: boolean;
  onActionCallback: (actionType: PurchaseOrderActionType) => void;
}
export const PurchaseOrderAction = ({
  purchaseOrder,
  isEditable = true,
  onActionCallback,
}: PurchaseOrderActionProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { fetchLabel, commonLabels } = useSiteCore();
  const { commonARIALabel } = useNavigationSiteCore();

  const { purchaseOrderTitle, managePoTransactionsCta, viewPoDetails } =
    purchaseOrdersListSiteCoreKeys;

  const getLabel = (key: string) => {
    return fetchLabel(purchaseOrderTitle, key);
  };

  const isStatusClosed = purchaseOrder.statusId === STATUS_BADGE_TYPE.closed;
  const showDeleteOption = !(
    isStatusClosed || purchaseOrder.isInvoiceGenerated
  );

  const onSelectAction = (type: PurchaseOrderActionType) => {
    handleClose();
    onActionCallback(type);
  };

  return (
    <>
      <MuiIconButton
        className="action-btn"
        id={purchaseOrder.clientId}
        onClick={handleClick}
        aria-controls={open ? purchaseOrder.clientId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        aria-label={commonARIALabel.moreOptionsForThisTableRow}
      >
        <MoreVertIcon />
      </MuiIconButton>
      <Menu
        id={purchaseOrder.clientId}
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
      >
        {isEditable ? (
          <>
            <PermissionWrapper
              permission={MODULE_PERMISSIONS.EDIT_CLIENT_PURCHASE_ORDER}
            >
              {!isStatusClosed && (
                <MenuItem
                  data-testId="edit"
                  onClick={() => onSelectAction("edit")}
                >
                  {commonLabels.edit}
                </MenuItem>
              )}
            </PermissionWrapper>
            <PermissionWrapper
              permission={MODULE_PERMISSIONS.DELETE_CLIENT_PURCHASE_ORDER}
            >
              {showDeleteOption && (
                <MenuItem
                  data-testId="delete"
                  onClick={() => onSelectAction("delete")}
                >
                  {commonLabels.delete}
                </MenuItem>
              )}
            </PermissionWrapper>

            <PermissionWrapper
              permission={MODULE_PERMISSIONS.VIEW_CLIENT_PURCHASE_ORDER}
            >
              <MenuItem
                data-testId="view-po"
                onClick={() => onSelectAction("viewPoTransactions")}
              >
                {getLabel(viewPoDetails)}
              </MenuItem>
            </PermissionWrapper>
            <PermissionWrapper
              permission={MODULE_PERMISSIONS.EDIT_CLIENT_PURCHASE_ORDER}
            >
              {!isStatusClosed && (
                <MenuItem
                  data-testId="manage-po"
                  disabled={isStatusClosed}
                  onClick={() => onSelectAction("managePoTransactions")}
                >
                  {getLabel(managePoTransactionsCta)}
                </MenuItem>
              )}
            </PermissionWrapper>
          </>
        ) : (
          <PermissionWrapper
            permission={MODULE_PERMISSIONS.VIEW_CLIENT_PURCHASE_ORDER}
          >
            <MenuItem
              data-testId="view-po"
              onClick={() => onSelectAction("viewPoTransactions")}
            >
              {getLabel(viewPoDetails)}
            </MenuItem>
          </PermissionWrapper>
        )}

        {isStatusClosed && isEditable && (
          <PermissionWrapper
            permission={MODULE_PERMISSIONS.EDIT_CLIENT_PURCHASE_ORDER}
          >
            <MenuItem
              data-testId="reopen-po"
              onClick={() => onSelectAction("reOpenPoNumber")}
            >
              {commonLabels.reOpen}
            </MenuItem>
          </PermissionWrapper>
        )}
      </Menu>
    </>
  );
};
